import { useEffect, useState } from 'react';
import api from './api';
import { setKnownManufacturers } from './quickListHelpers';

// Manufacturer names from our database, loaded once and shared by the Quick List pages
let cache = null;
let pending = null;

const loadManufacturerNames = () => {
  if (cache) return Promise.resolve(cache);
  if (!pending) {
    pending = api
      .exportManufacturer()
      .then(({ data }) => {
        const list = Array.isArray(data?.data) ? data.data : [];
        cache = [...new Set(list.map((m) => String(m?.name || '').trim()).filter(Boolean))].sort((a, b) =>
          a.localeCompare(b)
        );
        setKnownManufacturers(cache);
        return cache;
      })
      .catch((err) => {
        console.log(err);
        pending = null;
        return [];
      });
  }
  return pending;
};

export const useManufacturerNames = () => {
  const [names, setNames] = useState(cache || []);
  useEffect(() => {
    let active = true;
    loadManufacturerNames().then((list) => {
      if (active) setNames(list);
    });
    return () => {
      active = false;
    };
  }, []);
  return names;
};
